/**
 * Login View - Component Definition
 * ==================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { LoginController } from './controller';
import { LOGIN_TEMPLATE } from './template';
import { DEFAULTS, APPLE_LOGO, GOOGLE_LOGO, BASE_CLASSES } from './constants';

import { MODULE_NAME as INPUT_TEXT_MODULE } from '../../components/InputText';
import { MODULE_NAME as INPUT_PASSWORD_MODULE } from '../../components/InputPassword';
import { MODULE_NAME as BUTTON_MODULE } from '../../components/Button';

export interface ILoginComponentBindings {
  // Estado desde la app
  loading?: boolean;
  errorMessage?: string;
  showApple?: boolean;
  showGoogle?: boolean;
  showTerms?: boolean;

  // Textos
  title?: string;
  subtitle?: string;
  appleText?: string;
  googleText?: string;
  dividerText?: string;
  emailPlaceholder?: string;
  passwordPlaceholder?: string;
  submitText?: string;
  forgotText?: string;
  registerQuestion?: string;
  registerText?: string;
  termsPrefix?: string;
  termsLinkText?: string;
  termsConnector?: string;
  privacyLinkText?: string;

  // Callbacks
  onAppleLogin?: () => void;
  onGoogleLogin?: () => void;
  onSubmit?: (args: { email: string; password: string }) => void;
  onForgotPassword?: () => void;
  onRegister?: () => void;
  onTerms?: () => void;
  onPrivacy?: () => void;
}

export const loginComponentDefinition: IComponentOptions = {
  template: LOGIN_TEMPLATE,
  controller: LoginController,
  bindings: {
    loading: '<',
    errorMessage: '@',
    showApple: '<',
    showGoogle: '<',
    showTerms: '<',

    title: '@',
    subtitle: '@',
    appleText: '@',
    googleText: '@',
    dividerText: '@',
    emailPlaceholder: '@',
    passwordPlaceholder: '@',
    submitText: '@',
    forgotText: '@',
    registerQuestion: '@',
    registerText: '@',
    termsPrefix: '@',
    termsLinkText: '@',
    termsConnector: '@',
    privacyLinkText: '@',

    onAppleLogin: '&?',
    onGoogleLogin: '&?',
    onSubmit: '&?',
    onForgotPassword: '&?',
    onRegister: '&?',
    onTerms: '&?',
    onPrivacy: '&?'
  }
};

export const MODULE_NAME = 'ec.loginView';

const loginViewModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize', INPUT_TEXT_MODULE, INPUT_PASSWORD_MODULE, BUTTON_MODULE])
  .component('ecLogin', loginComponentDefinition);

export { LoginController, LOGIN_TEMPLATE, DEFAULTS, APPLE_LOGO, GOOGLE_LOGO, BASE_CLASSES };
export default loginViewModule;
